exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#enter-id .container {\n  max-width: 1350px; }\n\n.error-message p {\n  text-align: center;\n  padding: 10px;\n  background-color: #dc3545;\n  margin: 0;\n  font-size: 18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/routes/enterid/enterid.component.scss
// module id = ../../../../../src/app/routes/enterid/enterid.component.scss
// module chunks = main